export default __webpack_public_path__ + "8564bd5660c6b3040a5bd50c7662148b.svg";